'use client';

import { type ReactNode } from 'react';

import ErrorBoundary from '@/components/error-boundary';
import { reportException } from '@/utils/arms';

import StoryCardSkeleton from './story-card-skeleton';

interface IProps {
    children: ReactNode;
}

/** StoryCardGrid 动态加载失败时的局部降级边界，避免整页落入路由 error.tsx */
export default function StoryCardGridBoundary({ children }: IProps) {
    return (
        <ErrorBoundary
            fallback={<StoryCardSkeleton />}
            onError={(error, errorInfo) => {
                reportException(error.name, error.message, {
                    stack: error.stack,
                    properties: {
                        componentStack: errorInfo.componentStack,
                    },
                });
            }}
        >
            {children}
        </ErrorBoundary>
    );
}
